import script from "./AuthShopChange.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthShopChange.vue?vue&type=script&lang=ts&setup=true"

import "./AuthShopChange.vue?vue&type=style&index=0&id=067346c4&lang=scss"

const __exports__ = script;

export default __exports__